var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FITFormCard',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',[_vm._v(_vm._s(_vm.$t('adm.userAuthorization.change.header')))])]),_vm._v(" "),_c('div',{attrs:{"slot":"formBody"},slot:"formBody"},[_c('AuthorizationChange',{attrs:{"candidates":_vm.fakeCandidates,"callback":_vm.callback}})],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f985c33","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Adm/UserAuthorization/components/AuthorizationChangeWrapper.vue
// module id = null
// module chunks = 